import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur pluggar jag effektivt inför kunskapsprovet?";
const SHORT_ANSWER = "Träna 20–30 minuter dagligen i 2–4 veckor, jobba per kunskapsområde och fokusera på dina svaga områden i slutet.";

export const Route = createFileRoute("/fraga/hur-pluggar-jag-effektivt")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur pluggar jag effektivt inför kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Läs alkohollagen översiktligt, gå sedan direkt till övningsfrågor – aktiv återhämtning slår passiv läsning. Använd provsimulering inför skarpt prov för att vänja dig vid tidspress."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/plugga-kunskapsprovet", label: "4-veckors pluggschema" }}
      related={[{"to": "/fraga/kan-jag-trana-gratis", "label": "Kan jag träna på kunskapsprovet gratis?"}, {"to": "/fraga/vad-betyder-pbi", "label": "Vad betyder PBI?"}, {"to": "/fraga/ar-provet-svart", "label": "Är kunskapsprovet svårt?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur pluggar jag effektivt inför kunskapsprovet?" },
      { name: "description", content: "Träna 20–30 minuter dagligen i 2–4 veckor, jobba per kunskapsområde och fokusera på dina svaga områden i slutet." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-pluggar-jag-effektivt" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-pluggar-jag-effektivt" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-pluggar-jag-effektivt",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur pluggar jag effektivt inför kunskapsprovet", url: "https://alkoholprovet.se/fraga/hur-pluggar-jag-effektivt" },
      ]),
    ],
  }),
});
